import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { getVideo, cleanSingleVideo } from "../../Redux/Actions/videos";
import VideoTabHeader from "./Header";
import Detail from "./Detail";
import Share from "./Share";
import Analytics from "./Analytics";
import Design from "./Design";
import Templates from "../Templates/TemplateIs";
import Header from "../../components/Header/Header";
import "./style.css";

const { availableTheme } = require("../../constants/constants");

const tabs = [
  { key: "details", label: "Details" },
  { key: "analytics", label: "Analytics" },
  { key: "editing", label: "Editing" },
  { key: "share", label: "Share" },
  { key: "preview", label: "Preview" },
];

const VideoTab = ({ getVideo, cleanSingleVideo, video, profile }: any) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [previewTheme, setPreviewTheme] = useState<any>(availableTheme[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getVideo(id);
    return () => {
      cleanSingleVideo();
    };
  }, [getVideo, id]);

  useEffect(() => {
    if (video?.eMailTemplate) {
      const saved = availableTheme.find((t: any) => t.name === video.eMailTemplate);
      if (saved) setPreviewTheme(saved);
    }
  }, [video?.eMailTemplate]);

  const handleTemplateChange = (theme: any) => {
    setPreviewTheme(theme);
  };

  return (
    <>
      <Header
        styles={{
          backgroundImage:
            "linear-gradient(-90deg, rgb(97, 181, 179), rgb(97, 181, 179), rgb(252, 179, 23))",
        }}
      />
      <div className="vtPage">
        <div className="vtTopBar">
          <button className="vtBackBtn" onClick={() => navigate("/")}>
            <ArrowBackIcon style={{ fontSize: 16 }} />
            <span>Back to Dashboard</span>
          </button>
          {video && <h1 className="vtPageTitle">{video.title || "Untitled Video"}</h1>}
        </div>

        <div className="vtLayout">
          {/* Left: Video Preview */}
          <div className="vtLeftCol">
            <VideoTabHeader onTemplateChange={handleTemplateChange} />
          </div>

          {/* Right: Tabs Panel */}
          <div className="vtRightCol">
            <div className="vtTabBar">
              {tabs.map((tab, i) => (
                <button
                  key={tab.key}
                  className={`vtTab ${tabIndex === i ? "vtTabActive" : ""}`}
                  onClick={() => setTabIndex(i)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="vtTabContent">
              {tabIndex === 0 && <Detail />}
              {tabIndex === 1 && <Analytics />}
              {tabIndex === 2 && <Design />}
              {tabIndex === 3 && <Share />}
              {tabIndex === 4 && (
                <div className="vtPreviewPanel">
                  {previewTheme?.name && video ? (
                    <Templates tempName={previewTheme.name} video={video} profile={profile} />
                  ) : (
                    <p className="vtPreviewEmpty">Loading template preview...</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  loadingVideo: state.video.loadingVideo,
  video: state.video.singleVideo,
  profile: state.profile,
});
const mapDispatchToProps = (dispatch: any) => ({
  getVideo: (id: any) => dispatch(getVideo(id)),
  cleanSingleVideo: () => dispatch(cleanSingleVideo()),
});
export default connect(mapStateToProps, mapDispatchToProps)(VideoTab);
